import { PoItemVariant } from "./po-item-variant";

export class PoItemDetails {
    materialNo: string;
    poItem: string;
    season: string;
    incoterms: string;
    contractualDeliveryDate: string;
    inboundPkg: string;
    incotermsPlace: string;
    handoverDate: string;
    mfgProcess: string;
    harbor: string;
    shipMode: string;
    model: string;
    productType: string;
    merchDivision: string;
    colorDescription: string;
    class: string;
    conceptShortDesc: string;
    fabricContent: string;
    board: string;
    fishWildlifeInd: string;
    gender: string;
    downFeatherInd: string;
    fabrication: string;
    poItemVariantDetails: PoItemVariant[]

}